/**
 * Date-extensions locale Arabic (Kuwait) [ar-kw]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ar-kw', {
    monthNames: ['يناير','فبراير','مارس','أبريل','ماي','يونيو','يوليوز','غشت','شتنبر','أكتوبر','نونبر','دجنبر'],
    monthShortNames: ['يناير','فبراير','مارس','أبريل','ماي','يونيو','يوليوز','غشت','شتنبر','أكتوبر','نونبر','دجنبر'],
    dayNames: ['الأحد','الإتنين','الثلاثاء','الأربعاء','الخميس','الجمعة','السبت'],
    dayShortNames: ['احد','اتنين','ثلاثاء','اربعاء','خميس','جمعة','سبت']
});
